/* size of folder */
export const checkFolderSizes = async (path) => {
    if(!path) return
    
    try {
        const exists = await window?.electronAPI?.fse.existsSync(path);
        if(!exists) return 

        const files = await window?.electronAPI?.recursive(path)

        let fileCount = 0;
        let totalSize = 0;

        for (const file of files) {
            const stats = window?.electronAPI?.fse.statSync(file);
            fileCount++;
            totalSize += stats.size;      
        }

        // Convert bytes to MB
        const totalSizeMB = (totalSize / (1024 * 1024)).toFixed(2);

        return { 
            fileCount, 
            totalSize, 
            totalSizeMB,
            error: null 
        };
    } catch (error) {
        return { 
            fileCount: 0, 
            totalSize: 0, 
            error: error.message 
        };
    }
}

// Write txt for Reaper 
export const writeFile = async (content, filePath = null) => {
    const API = window?.electronAPI
    
    const platform = API?.os.platform();
    const finalPath = filePath || platform === 'win32' ? 
                                "C:\\ReaperTools\\scripts\\services\\AM\\data.kam"
                                :
                                "/Users/shared/ReaperTools/scripts/services/AM/data.kam"
    
    return new Promise((resolve, reject) => {
        API?.fse.writeFile(finalPath, content, function (err) {        
            if (err) {
                reject(err);
            } else {
                resolve(true);
            }
        });
    });
}


// RegEx path /which\
export const cleanPath = (pathString) => {
    return pathString.replace(/[\/\\]/g, ' ∕ ');
}

export const findDBIds = (filesArray) => {
    const result = { source: [], target: [] };

    filesArray.forEach(file => {
        const extracted = idsExtractor(file.name);
        
        if (extracted) {
            if (extracted.type === 'target') {
                result.target.push(extracted.id);
            } else {
                result.source.push(extracted.id);
            }
        }
    });
    return result;
}

export const idsExtractor = (string) => {
    // Find last square bracket content
    const match = string.match(/\[([^\]]+)\](?!.*\[)/);
    
    if (!match || !match[1]) {
        return null;
    }
    
    const content = match[1]; // e.g., "T8441513"
    const firstChar = content.charAt(0); // e.g., "T"
    const id = content.substring(1); // e.g., "8441513"
    
    // Parse ID as number
    const numericId = parseInt(id, 10);
    
    if (isNaN(numericId)) {
        return null;
    }
    
    return {
        type: firstChar === 'T' ? 'target' : 'source',
        id: numericId,
        kid: content
    };
}

// check if path exists
export const checkPath = async (path) => {
    if(!path) return false;
    if(await window?.electronAPI?.fse.existsSync(path)) return true;
    return false;
}

export const editorSanityCheck = async (props) => {
    const errors = []
    if(!props.tempFolder){
        errors.push('Temp Folder is not yet set')
    }
    if(!props.audioEditor){
        errors.push('Audio Editor is not yet set')
    }

    if(!props.tempFolder && !props.audioEditor){
        return errors
    }               
    const folderExist = await checkPath(props.tempFolder)
    if(!folderExist && props.tempFolder){
        errors.push('Temp Folder does not exist')
    }
    
    const audioEditorExist = await checkPath(props.audioEditor)
    if(!audioEditorExist && props.audioEditor){
        errors.push('Audio Editor does not exist')
    }

    return errors
}

export const ProgressCircle = ({ progress }) => {
    const radius = 13;
    const circumference = 2 * Math.PI * radius;
    const safeProgress = Math.max(0, Math.min(100, progress || 0));
    const offset = circumference - (safeProgress / 100) * circumference;
    const isComplete = safeProgress === 100;
    
    return (
        <svg width="30" height="30" className="progress-circle">
            <circle
                cx="15" cy="15" r={radius}
                fill={isComplete ? "#198754" : "none"}
                stroke={isComplete ? "#198754" : "#e9ecef"}
                strokeWidth="3"
            />
            {!isComplete && (
                <circle
                    cx="15" cy="15" r={radius}
                    fill="none"
                    stroke="#0d6efd"
                    strokeWidth="3"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    transform="rotate(-90 15 15)"
                />
            )}
            {isComplete ? (
                <path
                    d="M9 15 L13 19 L21 11"
                    stroke="white"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ) : (
                <text x="15" y="18" textAnchor="middle" fontSize="8" fill="#000">
                    {safeProgress}%
                </text>
            )}
        </svg>
    );
}



export const extractItemBlocks = (content) => {
    const lines = content.split('\n');
    const items = [];
    let currentItem = null;
    let depth = 0;
    
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        
        if (line.startsWith('<ITEM')) {
            currentItem = [lines[i]];
            depth = 1;
        } else if (currentItem) {
            currentItem.push(lines[i]);
            
            if (line.startsWith('<') && !line.startsWith('</')) {
                depth++;
            } else if (line === '>') {
                depth--;
                
                if (depth === 0) {
                    items.push(currentItem.join('\n'));
                    currentItem = null;
                }
            }
        }
    }
    
    return items;
}

export const searchAndFindInSessions = async (folderPath, searchData, onProgress) => {
    const API = window?.electronAPI;
    
    let filesLower = [];
    let filesUpper = [];
    
    try {
        filesLower = await API.recursive(folderPath, ["!*.rpp"]);
    } catch (error) {
        console.error("Error searching for .rpp files:", error.message);
    }
    
    try {
        filesUpper = await API.recursive(folderPath, ["!*.RPP"]);
    } catch (error) {
        console.error("Error searching for .RPP files:", error.message);
    }

    const files = [...new Set([...filesLower, ...filesUpper])];

    const sortedFiles = files.sort();
    const totalSessions = sortedFiles.length;
    
    const foundSessions = [];
    const targetIdStr = searchData.script_data_id.toString();
    const sourceFilename = searchData.source_filename.toString();

    for (let i = 0; i < sortedFiles.length; i++) {
        const file = sortedFiles[i];
        
        try {
            const content = await API.fse.readFile(file, 'utf-8');
            const extractItems = extractItemBlocks(content);
            const foundMatch = [];

            for (const item of extractItems){
                var found = false;
                const findIdAMTAG = new RegExp(`\\bAM\\s+${targetIdStr}\\b`);
                
                if(findIdAMTAG.test(item)){
                    found = true;
                } else {
                    // Escape special regex characters filenames
                    const escapedSearch = sourceFilename.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

                    const lines = item.split('\n');
                    for (const line of lines) {
                        // Pattern to find NAME followed by filename (case-insensitive)
                        const findNamePattern = new RegExp(`^\\s*NAME\\s+.*${escapedSearch}`, 'i');
                        
                        if(findNamePattern.test(line)){
                            found = true;
                            break;
                        }
                    }
                }


                if(found === true){
                    const positionMatch = item.match(/POSITION\s+([\d.]+)/);
                    const nameMatch = item.match(/NAME\s+(.+)/);
            
                    foundMatch.push({
                        found: true,
                        position: positionMatch ? parseFloat(positionMatch[1]) : null,
                        itemName: nameMatch ? nameMatch[1].trim() : "Unknown"
                    });
                }
            }
            
            // If it found tags, add it to the results and notify the progress
            if (foundMatch.length > 0) {
                const sessionResult = {
                    path: file,
                    name: file.split('\\').pop(),
                    status: 'completed',
                    hasTag: true,
                    tags: foundMatch,
                    tagCount: foundMatch.length
                };
                
                foundSessions.push(sessionResult);
                
                // Callback for progressive update
                if (onProgress) {
                    onProgress({
                        session: sessionResult,
                        currentIndex: i,
                        totalSessions: totalSessions,
                        foundCount: foundSessions.length
                    });
                }
            }

        } catch (error) {
            console.error(`Error reading session ${file}:`, error.message);
        }
    }
    
    return {
        sessions: foundSessions,
        totalSessions: totalSessions
    };
}

// Listen to WebSocket messages from Reaper independently
export const ww_reaperListen = (callback) => {
    const messageHandler = (message) => {
        try {
            const parsedMessage = JSON.parse(message);
            callback(parsedMessage);
        } catch (error) {
            console.error('Errore parsing messaggio Reaper:', error);
        }
    };
 
    // Add listener for WebSocket messages
    window?.electronAPI?.onReaperMessage(messageHandler);
 
    // Return cleanup function
    return () => {
        window?.electronAPI?.removeReaperListener?.();
    };
}

export const replaceMissingSpecsData = (value, setAs) => {
    return (value === undefined || value === null || value === "" || value === 0) ? setAs : value;
}

export const buildFiletypeMapScriptGrid = (scriptData, sourceFileTypes, kamUserFiletypes = []) => {
    const filetypeMap = {};
    
    scriptData.forEach(el => {
        // target_filetypes and target_audio are already parsed by manipulatedStrings
        if(el.target_filetypes) {
            if(!filetypeMap[el.script_id]) {
                filetypeMap[el.script_id] = {
                    script_name: el.script_name,
                    targetFiletypes: new Map(),
                    sourceFiletypes: new Map()
                };
            }
            
            // Target filetypes - include all, not just those with audio
            Object.keys(el.target_filetypes).forEach(filetypeId => {
                filetypeMap[el.script_id].targetFiletypes.set(filetypeId, {
                    id: parseInt(filetypeId),
                    filetypeName: el.target_filetypes[filetypeId],
                    default: false
                });
            });
            
            // Source filetypes - include all available source filetypes
            if(el.souce_types_id && el.souce_types_name && sourceFileTypes) {
                const sourceIds = el.souce_types_id.split('|');
                const sourceNames = el.souce_types_name.split('|');
                
                sourceIds.forEach((filetypeId, idx) => {
                    filetypeMap[el.script_id].sourceFiletypes.set(filetypeId, {
                        id: parseInt(filetypeId),
                        filetypeName: sourceNames[idx],
                        default: false
                    });
                });
            }
        }
    });
    
    // Convert Map to array for each script_id
    Object.keys(filetypeMap).forEach(scriptId => {
        const sourceArray = Array.from(filetypeMap[scriptId].sourceFiletypes.values());
        const targetArray = Array.from(filetypeMap[scriptId].targetFiletypes.values());
        
        // Check if user has saved preferences for this script
        const userPrefs = kamUserFiletypes.find(pref => parseInt(pref.script_id) === parseInt(scriptId));
        
        if(userPrefs) {
            // Apply saved source default
            if(userPrefs.source_filetype_id) {
                const sourceToSet = sourceArray.find(s => s.id === parseInt(userPrefs.source_filetype_id));
                if(sourceToSet) {
                    sourceToSet.default = true;
                }
            }
            
            // Apply saved target default
            if(userPrefs.target_filetype_id) {
                const targetToSet = targetArray.find(t => t.id === parseInt(userPrefs.target_filetype_id));
                if(targetToSet) {
                    targetToSet.default = true;
                }
            }
        } else {
            // If no user preferences, set as default if there's only one option
            if(sourceArray.length === 1) {
                sourceArray[0].default = true;
            }
            if(targetArray.length === 1) {
                targetArray[0].default = true;
            }
        }
        
        filetypeMap[scriptId] = {
            script_name: filetypeMap[scriptId].script_name,
            source: sourceArray,
            target: targetArray
        };
    });
    
    return filetypeMap;
}

/**
 * Prepare data for opening in external editor or importing to Reaper
 * @param {Array} elements - Array of grid row elements
 * @param {Object} context - Context object with sourceAudioBase, sourceFileTypes, kamFileTypesMap, tcColors
 * @returns {Object} - { editorData: [], reaperData: [] }
 */
export const prepareKRASTData = (elements, context) => {
    const { sourceAudioBase, sourceFileTypes, kamFileTypesMap, tcColors } = context;
    const editorData = [];
    const reaperData = [];
    
    elements.forEach(currentElement => {
        const scriptConfig = kamFileTypesMap?.[currentElement?.script_id];
        const defaultSource = scriptConfig?.source?.find(ft => ft.default);
        const defaultTarget = scriptConfig?.target?.find(ft => ft.default);
        
        // Skip if no default target configured
        if(!defaultTarget) return;
        
        const sourceFiletypeId = defaultSource?.id || Object.keys(sourceFileTypes)[0];
        const linkString = `${sourceFiletypeId}|${currentElement?.source_link_id.toLowerCase()}`;
        const tcInfo = tcColors.find(tc => tc.tc_code === currentElement.tc_code)?.background;
        
        const filetypes = currentElement.target_filetypes;
        const audioData = currentElement.target_audio;
        const filename = currentElement.target_filename;
        
        // Skip if no target filetypes
        if(!filetypes || Object.keys(filetypes).length === 0) return;
        if(!audioData || !audioData[0]) return;
        
        const k = defaultTarget.id.toString();
        
        // Skip if this specific filetype doesn't exist in audioData
        if(!audioData[0].hasOwnProperty(k)) return;
        
        // Check if ANY filetype has audio with active=1
        const hasAnyAudio = Object.values(audioData[0]).some(ft => ft && ft.s3 && ft.active === 1);
        if(!hasAnyAudio) return;
        
        // Check if the SELECTED filetype has audio with active=1
        const audioExists = audioData[0][k] && audioData[0][k].s3 && audioData[0][k].active === 1;
        const serverFilename = audioExists ? audioData[0][k].s3 : null;
        
        // Skip ghost mode files (no audio exists)
        if(!audioExists) return;
        
        const dataItem = {
            ...currentElement,
            tc_code_media: currentElement.tc_code,
            s3_path_s: sourceAudioBase[linkString]?.s3.replace('project-', ''),
            s3_path_t: serverFilename ? serverFilename.replace('project-', '') : null,
            filename_expected: filename,
            constraint: { krast_background: tcInfo },
            fileTypeId: k
        };
        
        // Add to both arrays (will be filtered by the specific function)
        editorData.push(dataItem);
        reaperData.push(dataItem);
    });
    
    return { editorData, reaperData };
}